import React from 'react';
import { Box, Typography } from '@mui/material';
import colors from 'colors/color';

const TextDivider = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        my: 2,
        '&::before, &::after': {
          content: '""',
          flex: 1,
          borderBottom: `1px solid #0017E74D`,
        },
        '&::before': {
          marginRight: 1,
        },
        '&::after': {
          marginLeft: 1,
        }
      }}
    >
      <Typography
        sx={{
          color: colors.primary,
          fontFamily: 'Poppins',
          fontWeight: 400, 
          fontSize: 14
        }}
      >
        {children}
      </Typography>
    </Box>
  );
};

export default TextDivider;
